class PaymentForm {
	id = 0;
	date = new Date().toISOString().split('T')[0];
	due_date = new Date().toISOString().split('T')[0];
	payment_category_id = null;
	amount = null;
	postage_amount = null;
	payment_form_delivery_type_id = 3;
	invoice_text = null;
	member_id = null;
	payment_id = null;
	returned = false;
	default_amounts = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default PaymentForm;
